export default __webpack_public_path__ + "0fde5d35ebb3512eb6b0f8232bfb40c9.webp";